"use strict";
/**
 * Trade units, for the review screen: the same table and rules as the AI service's
 * apps/ai/app/services/units.py, which converts what the retailer said before staff see it.
 * One mistake here is a 50x-off order, so a web test checks the two tables match: change
 * both together.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBaseQty = exports.canonicalUnit = exports.FIXED_FACTORS = exports.UNIT_MAP = void 0;
/** Spoken and Tally unit names -> one name per unit. */
exports.UNIT_MAP = {
    peti: 'peti',
    petti: 'peti',
    pete: 'peti',
    "peti's": 'peti',
    पेटी: 'peti',
    पेटे: 'peti',
    पेटि: 'peti',
    पेट्टी: 'peti',
    case: 'peti',
    cases: 'peti',
    carton: 'peti',
    cartons: 'peti',
    ctn: 'peti',
    box: 'peti',
    boxes: 'peti',
    बॉक्स: 'peti',
    बोक्स: 'peti',
    डिब्बा: 'peti',
    डिब्बे: 'peti',
    dibba: 'peti',
    dibbe: 'peti',
    katta: 'katta',
    katte: 'katta',
    कट्टा: 'katta',
    कट्टे: 'katta',
    bora: 'katta',
    bori: 'katta',
    बोरा: 'katta',
    बोरी: 'katta',
    bag: 'katta',
    bags: 'katta',
    dozen: 'dozen',
    doz: 'dozen',
    dzn: 'dozen',
    darjan: 'dozen',
    दर्जन: 'dozen',
    packet: 'pcs',
    packets: 'pcs',
    pkt: 'pcs',
    pkts: 'pcs',
    पैकेट: 'pcs',
    पाकेट: 'pcs',
    piece: 'pcs',
    pieces: 'pcs',
    pc: 'pcs',
    pcs: 'pcs',
    no: 'pcs',
    nos: 'pcs',
    'no.': 'pcs',
    'nos.': 'pcs',
    number: 'pcs',
    numbers: 'pcs',
    adad: 'pcs',
    nag: 'pcs',
    नग: 'pcs',
    पीस: 'pcs',
    kg: 'kg',
    kgs: 'kg',
    kilo: 'kg',
    kilos: 'kg',
    kilogram: 'kg',
    kilograms: 'kg',
    किलो: 'kg',
    g: 'g',
    gm: 'g',
    gms: 'g',
    gram: 'g',
    grams: 'g',
    gramme: 'g',
    ग्राम: 'g',
    litre: 'ltr',
    litres: 'ltr',
    liter: 'ltr',
    liters: 'ltr',
    ltr: 'ltr',
    ltrs: 'ltr',
    l: 'ltr',
    लीटर: 'ltr',
    ml: 'ml',
    mls: 'ml',
    millilitre: 'ml',
    milliliter: 'ml',
    bottle: 'bottle',
    bottles: 'bottle',
    btl: 'bottle',
    बोतल: 'bottle',
};
/** Conversions that are the same for every item: `said>base` -> factor. */
exports.FIXED_FACTORS = {
    'dozen>pcs': 12,
    'g>kg': 0.001,
    'kg>g': 1000,
    'ml>ltr': 0.001,
    'ltr>ml': 1000,
};
const canonicalUnit = (unit) => {
    const key = (unit ?? '').trim().toLowerCase();
    if (!key)
        return null;
    return exports.UNIT_MAP[key] ?? key;
};
exports.canonicalUnit = canonicalUnit;
const raw = (unit) => (unit ?? '').trim().toLowerCase();
/** 500 g x 0.001 is 0.5, not 0.5000000000000001. */
const round6 = (value) => Math.round(value * 1e6) / 1e6;
/**
 * A quantity in the unit it was said in, as the item's base unit. `null` = it can't be
 * worked out for sure, so a person decides (never a guess).
 */
const toBaseQty = (qty, unit, item) => {
    if (qty === null || qty === undefined)
        return null;
    const said = (0, exports.canonicalUnit)(unit);
    const base = (0, exports.canonicalUnit)(item.baseUnit);
    if (said === null)
        return qty;
    const packSize = item.packSize ?? 1;
    const pack = item.packUnit && packSize > 0 ? (0, exports.canonicalUnit)(item.packUnit) : null;
    // The pack and base are one unit by name (Tally "Pcs" with a "Pkt" of 10): only the exact
    // Tally name tells them apart.
    if (pack !== null && pack === base && packSize !== 1) {
        if (raw(unit) === raw(item.packUnit))
            return round6(qty * packSize);
        if (raw(unit) === raw(item.baseUnit))
            return qty;
        return null;
    }
    if (said === base)
        return qty;
    if (pack !== null && said === pack)
        return round6(qty * packSize);
    const factor = exports.FIXED_FACTORS[`${said}>${base ?? ''}`];
    return factor === undefined ? null : round6(qty * factor);
};
exports.toBaseQty = toBaseQty;
//# sourceMappingURL=units.js.map